const autoNgTemplateLoaderTemplate1 = require('./child-entity-list.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
  angular
    .module('app.childEntityList', [])
    .config(childEntityListConfig);

  childEntityListConfig.$inject = ['$routeProvider'];

  function childEntityListConfig($routeProvider) {
    $routeProvider
      .when('/child-entity-list', {
        disableCache: true,
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'ChildEntityListController',
        controllerAs: 'vm',
        reloadOnSearch: false,
        resolve: {
          loginRequired: ['AuthService', function (AuthService) {
            return AuthService.loginRequired();
          }]
        },
        pageConfig: {
          solution: SOLUTION_TYPE.NUTRITION,
        }
      })
  }
})();
